import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function resetPassword(params) {
    return await connection({ method: 'POST', url: `${AUTH_URL.RESET_PASSWORD}`, params: params });
}

export default resetPassword;
